import { Form } from "@redriver/cinnamon-mui";
import { qualityUsersLookup } from "modules/lookups";

const QualityUserTypeAhead = (props) => (
  <Form.TypeAhead lookup={qualityUsersLookup} {...props} />
);

export default QualityUserTypeAhead;
